
import { defineComponent } from 'vue'
import { useUserBlockLoader } from '@/composables/userBlock/userBlock'
import UserHeader from '@/components/Profile/Lists/Single/UserHeader.vue'
import AButton from '@/components/Forms/AButton.vue'
import BlockedUserItem from '@/components/Profile/Lists/Single/BlockedUserItem.vue'
import ALoader from '@/components/ALoader.vue'

export default defineComponent({
  name: 'BannedUsersList',
  components: { ALoader, BlockedUserItem, AButton, UserHeader },
  async setup() {
    const {
      loadNext,
      bannedUsers,
      loading,
      hasNext,
      loadedCount,
      totalCount,
      removeBlockedUser,
      clear,
    } = useUserBlockLoader()

    clear()
    await loadNext()

    return {
      loadedCount,
      totalCount,
      loading,
      hasNext,
      loadNext,
      removeBlockedUser,
      bannedUsers,
    }
  },
})
